export default __webpack_public_path__ + "static/media/Cardo.d6f2c704.woff";